// Handling minimised header
'use strict';

import $ from 'jquery';
import _ from 'underscore';
import mediator from '../../../js/mediator';
import Backbone from 'backbone';
import config from '../../../js/config';
import $global from '../../../js/globalElements';
import Analytics from '../../Analytics/Analytics';

const events = config.events;
const $window = $global.$window;

// Breakpoints on which the minimised header should be shown
const MINIMISED_HEADER_BREAKPOINTS = [
  'laptop',
  'desktop',
  'wide'
];

Backbone.$ = $;

export class MinimisedHeaderView extends Backbone.View {

  initialize() {
    var self = this;
    this.screenWidth = window.innerWidth;
    _.bindAll(this, 'onScroll', 'onResize', 'handleMinimisedHeader', 'expand');

    this.$parent = this.$el.parent('.head');
    this.parentHeight = this.$parent.outerHeight();
    mediator.on(events.ui.resize, this.onResize);

    if ($global.$body.hasClass('is-editor-view')) {
      return;
    }

    mediator.on(events.ui.load + ' ' + events.ui.scrollThrottle, this.onScroll);

    mediator.on(events.ui.resize, function() {
      // Incase the height as changed on resize.
      self.parentHeight = self.$parent.outerHeight();
    });

    // Get breakpoint events on which expand or minimise
    var expandBreakpoints   = _.chain(config.events.breakpoint).omit(MINIMISED_HEADER_BREAKPOINTS).toArray().value(),
      minimiseBreakpoints = _.chain(config.events.breakpoint).pick(MINIMISED_HEADER_BREAKPOINTS).toArray().value();

    // On breakpoints not having the minimised header, expand it
    mediator.on(expandBreakpoints.join(' '), this.expand);
    // When browser side changes to a breakpoint having minimised header, handle it
    mediator.on(minimiseBreakpoints.join(' '), this.handleMinimisedHeader);
    mediator.on(config.events.megaMenu.close, this.handleMinimisedHeader);
    this.onScroll();

  }

  onResize() {
    this.screenWidth = window.innerWidth;
    this.handleMinimisedHeader();
  }

  onScroll() {
    this.handleMinimisedHeader();
  }

  handleMinimisedHeader() {
    if (this.screenWidth >= config.breakpoints.laptop) {
      var scrollValue = $window.scrollTop();

      // On scroll and page load, check the scroll value and add or remove classes to body
      if (scrollValue <= this.parentHeight) {
        this.expand();
        // Reset the height if you have changed the window size.
        this.parentHeight = this.$parent.outerHeight();
      } else if (!mediator.get(config.state.header.typeaheadIsOpen)) {
        if (!$global.$body.hasClass(config.classes.isMegaMenuOpen)) {
          this.minimise();
        }
      }
    }
  }

  minimise() {
    if (this.isMinimised) return;
    this.isMinimised = true;
    const DIVISIONS_CLOSE = `${config.classes.isDivisionsMenu} ${config.classes.hasDivisionsMenu} ${config.classes.isHeaderDropdown}`;
    $global.$body
      // Close divisions menu
      .removeClass(DIVISIONS_CLOSE)
      // If the user scrolls long enough, display the minimised header
      .addClass(config.classes.isMinimisedHeader);
    this.timeout = setTimeout(() => {
      this.$parent.addClass(config.classes.isActive);
      $('.arrowdown').css('visibility', 'hidden');
      $('.arrowup').css('visibility', 'hidden');
    }, 50);
    $('.megamenu-wrapper ul li a.megamenu-newPill-link').attr('tabindex','-1');
    Analytics.setOnDataLayer({ header: { stickyHeader: true }});
    this.trigger('minimise');
    mediator.trigger(config.events.header.minimised);
    // Ensure that header divisions menu hides on scroll as well as any open dropdowns
    mediator.trigger(config.events.showHide.hideGroupHeader, {});
  }

  expand() {
    if (this.isMinimised === false) return;
    this.isMinimised = false;
    // When the user is back at the top, show the full header
    $global.$body.removeClass(config.classes.isMinimisedHeader);
    // Close the sticky search and account menu
    mediator.trigger(config.events.showHide.hideGroupHeader, {});
    clearTimeout(this.timeout);
    this.$parent.removeClass(config.classes.isActive);
    $('.megamenu-wrapper ul li a.megamenu-newPill-link').removeAttr('tabindex');
    $('.arrowdown').css('visibility', 'visible');
    $('.arrowup').css('visibility', 'visible');
    Analytics.setOnDataLayer({ header: { stickyHeader: false }});
    this.trigger('expand');
  }

}




// WEBPACK FOOTER //
// ./assets/components/Header/js/MinimisedHeaderView.js